/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_2faInputs */

const cs_settings_profile_2fa = /** @type {(inputs: Settings_Profile_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dvoufázové ověření`)
};

const en_settings_profile_2fa = /** @type {(inputs: Settings_Profile_2faInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Two-factor authentication`)
};

/**
* | output |
* | --- |
* | "Two-factor authentication" |
*
* @param {Settings_Profile_2faInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_2fa = /** @type {((inputs?: Settings_Profile_2faInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_2faInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_2fa(inputs)
	return cs_settings_profile_2fa(inputs)
});